import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

//사이드메뉴 스크롤값이 유지되게 해준다
const SidebarScrollState = () => {
  const { pathname } = useLocation();
  const [scrollState, setScrollState] = useState();
  const sideElement = document.querySelector('.sider');
  //   console.log(cookies);
  useEffect(() => {
    const sideElement = document.querySelector('.sider');
    sideElement &&
      sideElement.addEventListener('scroll', (e) => {
        setScrollState(sideElement.scrollTop);
      });
    sideElement && sideElement.scrollTo(0, scrollState);
  }, [pathname, sideElement && sideElement.scrollTop]);
  return null;
};

export default SidebarScrollState;
